export enum OrderState
{
    Draft = -1,
    Requested = 0,
    Scheduled = 1,
    Rejected = 2,
    Processing = 3,
    Completed = 4,
}